//用于存储全局变量
const globaldata = {
	//serverurl: 'http://192.168.0.99:801/',
	serverurl: 'http://wzs.sn58.cn/',
	
};

export default {
	globaldata	
}